
export const THEME_CALL = (_THEME) => {
   
    document.documentElement.style.setProperty('$primary-color', _THEME.primaryColor);
    document.documentElement.style.setProperty('--primaryColor', _THEME.primaryColor);
    document.documentElement.style.setProperty('--primaryWardColor', _THEME.primaryWardColor);
    document.documentElement.style.setProperty('--secondaryColor', _THEME.secondaryColor);

    if(!_THEME.showHeader){
        document.querySelectorAll(`body`).forEach(e => e.classList.add(`page-no-header`));
    }else{
        document.querySelectorAll(`body`).forEach(e => e.classList.remove(`page-no-header`));
    }

    document.querySelectorAll('.logo').forEach(e=>{
        e.setAttribute('src',_THEME.logo);
    })
}

export const THEME_CALL_WARD = (_THEME) => {
   
    document.documentElement.style.setProperty('$primary-color', _THEME.primaryWardColor);
    document.documentElement.style.setProperty('--primaryColor', _THEME.primaryWardColor);
    document.documentElement.style.setProperty('--primaryWardColor', _THEME.primaryWardColor);
    document.documentElement.style.setProperty('--secondaryColor', _THEME.secondaryWardColor);

    if(!_THEME.showHeader){
        document.querySelectorAll(`body`).forEach(e => e.classList.add(`page-no-header`));
    }else{
        document.querySelectorAll(`body`).forEach(e => e.classList.remove(`page-no-header`));
    }

    document.querySelectorAll('.logo').forEach(e=>{
        e.setAttribute('src',_THEME.logo);
    })
}